import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { useGlobalContext } from "../Config";
import FormBusquedaProductos from "../components/FormBusquedaProductos";
import ProductosDisponiblesTable from "../components/ProductosDisponiblesTable";
import UseScrollOnStateChange from "../components/UseScrollOnStateChange";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import StepByStep from "../components/StepByStep";
import Loader from "../components/Loader";
import FormCrearListaEspera from "../components/FormCrearListaEspera";
import { validateFiltrosProductosCabecera } from "../utilities/Helper";

const items = [
  {
    label: "Seleccione Cliente",
  },
  {
    label: "Seleccione Productos",
  },
  {
    label: "Añada Subproductos Y Servicios",
  },
  {
    label: "Defina Tarifas",
  },
];
const CotizacionSelectProductos = (props) => {
  const [displayDialog, setDisplayDialog] = useState(false);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const idCliente = parseInt(searchParams.get("idCliente"));
  const idCotizacion = parseInt(searchParams.get("idCotizacion"));
  const selected = searchParams.get("selected");
  const activeIndex = parseInt(searchParams.get("activeIndex"));
  const [carro, setCarro] = useState([]);
  const [cliente, setCliente] = useState(null);
  const { baseUrl } = useGlobalContext();
  const [empresa, setEmpresa] = useState("TODAS");
  const empresas = [
    { name: "TODAS", value: "TODAS" },
    { name: "ALTAMIRA", value: "Altamira" },
    { name: "LA SIEMBRA", value: "LA SIEMBRA" },
  ];
  const [showProductosEncontrados, setShowProductosEncontrados] =
    useState(false);
  const [tipoProducto, setTipoProducto] = useState("");
  const [tiposProducto, setTiposProducto] = useState([
    { id: 1, descripcion: "Bodega", code: "Bodega", cobro: "Factura Exenta" },
    { id: 2, descripcion: "Sitio", code: "Sitio", cobro: "Factura Exenta" },
    { id: 3, descripcion: "Casino", code: "Casino", cobro: "Factura Exenta" },
    { id: 4, descripcion: "Zona Lavado", code: "Zona Lavado", cobro: "Factura Exenta"},
  ]);
  const navigate = useNavigate();

  const [desde, setDesde] = useState(null);
  const [hasta, setHasta] = useState(null);
  const [regularizarCotizacion, setRegularizarCotizacion] = useState(false);
  const [rowClick, setRowClick] = useState(true);

  const [loading, setLoading] = useState(false);
  const [productosDisponibles, setProductosDisponibles] = useState([]);
  const [displayConstruccion, setDisplayConstruccion] = useState(false);

  const searchProductos = async () => {
    try {
      if (!isValidFiltrosProductos()) {
        return;
      }

      resetCarro();
      setProductosDisponibles([]);
      const empresasArray = mapEmpresas(empresa);
      const tiposArray = mapTipos(tipoProducto);
      const { desdeFiltro, hastaFiltro } = mapDateFilters(desde, hasta);

      setLoading(true);
      setShowProductosEncontrados(true);

      const url = buildProductosUrl(
        empresasArray,
        desdeFiltro,
        hastaFiltro,
        tiposArray
      );
      const data = await fetchData(url);
      handleProductosResponse(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
    setLoading(false);
  };

  const isValidFiltrosProductos = () => {
    if (!checkCabeceraFiltrosProductos()) {
      return false;
    }
    return true;
  };

  const checkCabeceraFiltrosProductos = () => {
    const { isValid, errorMessage } = validateFiltrosProductosCabecera({
      empresa,
      tipoProducto,
      desde,
      hasta,
      regularizarCotizacion,
    });

    if (errorMessage) {
      alert(errorMessage);
    }

    return isValid;
  };

  const mapEmpresas = (selectedEmpresa) => {
    const empresaMapping = {
      TODAS: ["2", "3"],
      ALTAMIRA: ["2"],
      "LA SIEMBRA": ["3"],
    };
    return empresaMapping[selectedEmpresa.toUpperCase()] || [];
  };

  const mapTipos = (tipoProductoArray) => {
    return tipoProductoArray.map((tipo) => tipo.descripcion);
  };
  const buildProductosUrl = (
    empresasArray,
    desdeFiltro,
    hastaFiltro,
    tiposArray
  ) => {
    return `${baseUrl}getProductosByFiltro?empresas=${empresasArray}&fechaInicio=${desdeFiltro}&fechaTermino=${hastaFiltro}&tipos=${tiposArray}`;
  };

  const handleProductosResponse = (data) => {
    if (Array.isArray(data.productos)) {
      setProductosDisponibles(data.productos);
      setLoading(false);
    } else {
      console.error("Data.clientes no es array:", data.clientes);
      setLoading(false);
    }
  };

  const mapDateFilters = (desde, hasta) => {
    const dateObjectDesde = new Date(desde);
    const dateObjectHasta = new Date(hasta);
    const desdeFiltro = dateObjectDesde.toISOString().split("T")[0];
    const hastaFiltro = dateObjectHasta.toISOString().split("T")[0];
    setDesdeFiltro(desdeFiltro);
    setHastaFiltro(hastaFiltro);

    return { desdeFiltro, hastaFiltro };
  };

  const [desdeFiltro, setDesdeFiltro] = useState("");
  const [hastaFiltro, setHastaFiltro] = useState("");

  const resetCarro = () => {
    setCarro([]);
  };

  const fetchDataCliente = async () => {
    try {
      const response = await fetch(
        `${baseUrl}getClienteById?idCliente=${idCliente}`
      );
      if (!response.ok) {
        throw new Error(
          `Network response was not ok. Status: ${response.status}`
        );
      }
      const data = await response.json();
      setCliente(data);
    } catch (error) {
      console.error("Error fetching client data:", error);
    }
  };
  const fetchData = async (url) => {
    const requestOptions = {
      method: "GET",
      headers: new Headers(),
      redirect: "follow",
    };

    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      throw new Error(
        `Network response was not ok. Status: ${response.status}`
      );
    }

    return response.json();
  };
  useEffect(() => {
    if (idCliente && selected === "true" && activeIndex) {
      fetchDataCliente();
    }
  }, [idCliente, selected]);

  const selectSubProductsAndServices = () => {
    if (carro.length <= 0) {
      alert("Seleccione al menos un producto");
    } else {
      // Update each item in carro to include tarifa_base attribute
      const updatedCarro = carro.map((item) => ({
        ...item,
        tarifa_base: item.tarifa_base,
      }));

      const carroEncoded = encodeURIComponent(JSON.stringify(updatedCarro));


      const newURL =
        `/selectSubProductosYServicios?activeIndex=2&selectedItems=${carroEncoded}&idCliente=${cliente.id}&selected=true&desde=${desdeFiltro}&hasta=${hastaFiltro}&idCotizacion=${idCotizacion}`;
      navigate(newURL);
    }
  };
  UseScrollOnStateChange(productosDisponibles, "productosDataTable");
  
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  return (
    <div className="card">
      {!isMobile && activeIndex && <StepByStep activeIndex={activeIndex} items={items}/>}

      {cliente && (
        <>
          <FormBusquedaProductos
            baseUrl={baseUrl}
            cliente={cliente}
            empresa={empresa}
            setEmpresa={setEmpresa}
            empresas={empresas}
            tipoProducto={tipoProducto}
            setTipoProducto={setTipoProducto}
            tiposProducto={tiposProducto}
            setTiposProducto={setTiposProducto}
            desde={desde}
            setDesde={setDesde}
            hasta={hasta}
            setHasta={setHasta}
            searchProductos={searchProductos}
            idCotizacion={idCotizacion}
            loading={loading}
            regularizarCotizacion={regularizarCotizacion}
            setRegularizarCotizacion={setRegularizarCotizacion}
          />
        </>
      )}
      {showProductosEncontrados && (
        <>
          {loading ? (
            <>
              <Loader></Loader>
            </>
          ) : (
            <div className="field col-12 md:col-12 mt-2">
              <ProductosDisponiblesTable
                productosDisponibles={productosDisponibles}
                loading2={loading}
                rowClick={rowClick}
                carro={carro}
                setCarro={setCarro}
                desdeFiltro={desdeFiltro}
                hastaFiltro={hastaFiltro}
                setDisplayDialog={setDisplayDialog}
                nombreEmpresa={empresa}
              />
            </div>
          )}

          <div
            className="field col-12 md:col-12"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Button
              label="Confirmar"
              icon="pi pi-check"
              className="mr-2 mb-2 p-button-success p-button-rounded"
              onClick={selectSubProductsAndServices}
              style={{ width: "400px" }}
              visible={!loading}
              raised
            />
          </div>
        </>
      )}
        
      <FormCrearListaEspera
        visible={displayDialog}
        onHide={() => setDisplayDialog(false)}
        idCliente={idCliente}
        setDisplayDialog={setDisplayDialog}
        empresa={empresa}
        setEmpresa={setEmpresa}
        empresas={empresas}
        tipoProducto={tipoProducto}
        setTipoProducto={setTipoProducto}
        tiposProducto={tiposProducto}
        setTiposProducto={setTiposProducto}
        baseUrl={baseUrl}
      />

    </div>
  );
};

export default CotizacionSelectProductos;
